import { RedirectRoute, Route } from "../classes/RouteTypes";

export default [
    new RedirectRoute({ path: '/', name: 'index', redirect: { name: 'login' } }),

    /* A következő kódrészlet ideiglenesen❗eltávolítva, 
       mivel jelenleg nincs szükség rá.
    
       new Route({
           path: '/impressum', name: 'impressum', label: 'navigation.impressum',
           component: () => import('../pages/guest/impressum/Frame'),
       }),
    */

];